export const COURSE_PAUSE_REQUEST_FILTERS = {
  learnerEmail: 'learnerEmail',
  currentBatch: 'currentBatch',
  newBatch: 'newBatch',
  fromToBeResumedDate: 'fromToBeResumedDate',
  untilToBeResumedDate: 'untilToBeResumedDate',
  pauseDuration: 'pauseDuration',
  courseType: 'courseType',
};
